import { Box, Heading, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PasskeyButton } from "../../common/auth/passkey/PasskeyButton";
import { useAppDispatch } from "../../common/redux/hooks";
import { reloadMeThunk } from "../../common/redux/thunks/auth/reload-me-thunk";
import { Reauthenticate } from "../personal-profile/edit/Reauthenticate";

export const AdminPasskeyStep = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [needsReauth, setNeedsReauth] = useState(false);

  if (needsReauth) return <Reauthenticate onReauthSuccessful={() => setNeedsReauth(false)} />;

  return (
    <Box maxW="container.sm">
      <Heading as="h1" size="lg" color="smText" mb="4">
        {t("Admin access needs a passkey")}
      </Heading>
      <Text color="smText" mb="2">
        {t("The admin tools reach every organisation's data, so they need a second step after your password.")}
      </Text>
      <Text color="smMuted" mb="6">
        {t(
          "The first time, your browser asks to save a passkey: with Touch ID, Windows Hello, your phone or a security key. After that you confirm with it; on another computer, the browser can use it from your phone or password manager."
        )}
      </Text>
      <PasskeyButton
        purpose="AddOrConfirm"
        label={t("Continue with passkey")}
        colorScheme="teal"
        onSuccess={() => void dispatch(reloadMeThunk())}
        onReauthRequired={() => setNeedsReauth(true)}
      />
    </Box>
  );
};
